import { render } from "./PopularShareTransactionModal.vue?vue&type=template&id=75921629&scoped=true&ts=true"
import script from "./PopularShareTransactionModal.vue?vue&type=script&lang=ts"
export * from "./PopularShareTransactionModal.vue?vue&type=script&lang=ts"

import "./PopularShareTransactionModal.vue?vue&type=style&index=0&id=75921629&scoped=true&lang=css"

import exportComponent from "/home/runner/work/angelleague-front/angelleague-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-75921629"]])

export default __exports__